import { jsxs, jsx } from "react/jsx-runtime";
import { Heading, Paragraph } from "@zillow/constellation";
const RatesArticle = ({
  article
}) => {
  return /* @__PURE__ */ jsxs("article", { children: [
    /* @__PURE__ */ jsx(Heading, { level: "5", as: "h3", children: article == null ? void 0 : article.title }),
    article == null ? void 0 : article.paragraphs.map((p) => /* @__PURE__ */ jsx(Paragraph, { marginTop: "md", children: p }, p)),
    /* @__PURE__ */ jsxs(Paragraph, { fontType: "finePrint", marginTop: "sm", children: [
      "Last updated: ",
      article == null ? void 0 : article.date
    ] })
  ] });
};
export {
  RatesArticle
};
